import { isItRealUrl } from "@lib/helpers/UrlHelper";
import * as yup from "yup";

export const scanConfigSchema = yup.object().shape({
  USDT: yup.object().shape({
    scanUrl: yup
      .string()
      .required()
      .min(10)
      .test({
        test: (value) => {
          return isItRealUrl(value);
        },
      }),
  }),
});
